import authWatcher from "../modules/auth/store/watcher";
import messageWatcher from "../modules/chat/store/watcher";
import taskWatcher from "../modules/task/store/watcher";
import commonWatcher from "../modules/common/store/watcher";
import { all } from "redux-saga/effects";
import usersWatcher from "../modules/users/store/watcher";
import sitesWatcher from "../modules/sites/store/watcher";
import propConfigWatcher from "../modules/propConfig/store/watcher";
import siteGroupWatcher from "../modules/siteGroup/store/watcher";
import taskNotificationWatcher from "../modules/taskNotification/store/watcher";

export default function* rootSaga() {
  yield all([
    authWatcher(),
    messageWatcher(),
    taskWatcher(),
	usersWatcher(),
    sitesWatcher(),
    siteGroupWatcher(),
    taskNotificationWatcher(),
	propConfigWatcher(),
	commonWatcher()
  ]);
}
